/** Global modal stack id for the Meridian marketplace skills inventory. */
export const CHAT_SKILLS_MODAL_ID = 'chat-skills';
